import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('whatsapp');

export class Areas extends Api {
    constructor(http, config = {}) {
        super(http, url, 'areas', config);
    }
}